import { green, headingBlue, maroon, mediumGrey, pureWhite, red, yellowish } from "../../assets/colors";

export const titleStyle = {
    backgroundColor: headingBlue,
    color: 'white',
    fontSize:'1rem',
    display: "flex",
    alignItems: 'center'
}

export const containerStyle = {
    marginTop: '1rem'
}

export const searchBarBoxStyle = {
    textAlign: 'center'
}

export const gridBoxStyle = {
    padding: '2rem 0rem 1rem 0rem',
    overflow: 'auto',
    "&::-webkit-scrollbar":{
    display: 'none'
    },
    scrollbarWidth: "none",
}

export const gridStyle = {
    padding: '0.5rem 0.2rem 0.2rem 0.2rem',
    color: headingBlue
}

export const selectedGridStyle = {
    padding: '0.5rem 0.2rem 0.2rem 0.2rem',
    color: maroon
}

export const gridCommonStyle= {
    textAlign: 'center',
    fontSize: '0.9rem',
    fontWeight: '600',
    borderBottom: `1px solid ${mediumGrey}`,
    borderRight: `1px solid ${mediumGrey}`,
    padding: '0.1rem'
}

export const buttonBoxStyle = {
    padding: '1rem 0.3rem 0rem 0.3rem',
    display:'flex',
    justifyContent: 'center'
}

export const buttonStyle = {
    color: pureWhite,
    backgroundColor: headingBlue,
    border: "1px solid #D9D9D9",
    marginRight: "0.3rem",
    fontFamily: "Helvetica",
    fontWeight: "500",
    fontSize: "0.9rem",
};

export const typographyStyle = {
    textAlign: 'center',
    fontSize: '1.2rem',
    color: red,
    padding: '0.5rem 0rem 0rem 0rem'
}

export const errorTypographyStyle = {
    color: red,
    padding: '0.75rem 0rem 0rem 0.2rem',
    textAlign: 'center',
    fontWeight: 500
}